var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BtnToggle',{attrs:{"title":'Icon'},on:{"click":_vm.chooseIcon,"click_":function($event){return _vm.addIcon()}}},[_c('i',{staticClass:"far fa-star fs-16"})])}
var staticRenderFns = []

export { render, staticRenderFns }